import { IBranding } from './interfaces/branding.interface';

// Runtime branding is keyed by the full hostname (window.location.hostname), matched one-to-one.
// Manager and Workshop domains for a customer are separate entries. A null primaryColor means the
// host keeps the app's compiled default $primary; a matched host overrides it at runtime.
export const DEFAULT_BRANDING: IBranding = {
  logoUrl: '/assets/images/insolution-logo.svg',
  primaryColor: null,
};

export const BRANDING_CONFIG: Record<string, IBranding> = {
  'manager-podofrance.insolution.nl': {
    logoUrl: '/assets/images/logo-podofrance.svg',
    primaryColor: '#158e30',
  },
  'uat.manager-podofrance.insolution.nl': {
    logoUrl: '/assets/images/logo-podofrance.svg',
    primaryColor: '#158e30',
  },
  'workshop-podofrance.insolution.nl': {
    logoUrl: '/assets/images/logo-podofrance.svg',
    primaryColor: '#158e30',
  },
  'uat.workshop-podofrance.insolution.nl': {
    logoUrl: '/assets/images/logo-podofrance.svg',
    primaryColor: '#158e30',
  },
};
